import {
  IntegrationCategory,
  MuSupportType,
} from './InternalIntegrationSetting';
import { PropertyBusinessType } from './Properties';

/**
 * This function returns true if a property businessType is supported by an integration based on the integration muSupportType.
 */
export const isBusinessTypeSupported = ({
  muSupportType,
  businessType,
}: {
  muSupportType: MuSupportType;
  businessType: PropertyBusinessType;
}) => {
  if (
    businessType !== PropertyBusinessType.HOTEL &&
    businessType !== PropertyBusinessType.UNIT_TYPE
  ) {
    return true;
  }

  if (muSupportType === MuSupportType.NONE) {
    return false;
  }

  if (muSupportType === MuSupportType.BOTH) {
    return true;
  }

  const isHotel = businessType === PropertyBusinessType.HOTEL;
  const isUnitType = businessType === PropertyBusinessType.UNIT_TYPE;

  return (
    (muSupportType === MuSupportType.HOTEL && isHotel) ||
    (muSupportType === MuSupportType.UNIT_TYPE && isUnitType)
  );
};

export const hasExclusiveConnectionRequirement = (
  category: IntegrationCategory,
): boolean => {
  return (
    category === IntegrationCategory.PAYMENTS ||
    category === IntegrationCategory.DYNAMIC_PRICING
  );
};
